// @flow
import styled from 'styled-components';

export const IconStyle = styled.g`fill: ${p => p.color || p.theme.fontColor};`;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/style.js